var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.configObj
    ? _c("div", { staticClass: "page-container" }, [
        _c("div", { staticClass: "bg-img" }, [
          _c("img", {
            attrs: {
              src: _vm.imgSrcList.length && _vm.imgSrcList[0].img,
              alt: "",
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "mask", style: _vm.maskStyle }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "search-box" }, [
          _vm.configObj.logoConfig.isShow === 1 && _vm.logoUrl
            ? _c("img", {
                attrs: { src: _vm.logoUrl, alt: "", mode: "widthFix" },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "box line1", style: _vm.contentStyle }, [
            _c("span", [
              _c("i", { staticClass: "el-icon-search" }),
              _c("span", [_vm._v(_vm._s(_vm.hotWord))]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.configObj.tabShowConfig.tabVal == 0,
                expression: "configObj.tabShowConfig.tabVal == 0",
              },
            ],
            staticClass: "menus",
          },
          [
            _vm._l(_vm.list, function (item, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "item line1",
                  class: { on: _vm.curIndex === index },
                  style: {
                    color:
                      _vm.curIndex === index
                        ? _vm.configObj.checkColor.color[0].item
                        : _vm.textColor,
                  },
                },
                [
                  _vm._v("\n      " + _vm._s(item.title) + " "),
                  _c("span", { style: _vm.checkColor }),
                ]
              )
            }),
            _vm._v(" "),
            _c("div", { staticClass: "category" }, [
              _c("span", {
                staticClass: "iconfont icon-shouye_xidingfenlei",
                style: _vm.checkColor,
              }),
            ]),
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "banner-two",
            class: _vm.configObj.tabShowConfig.tabVal == 1 ? "mt10" : "",
          },
          [
            _c("div", { staticClass: "img-box" }, [
              _vm.swiperType == 0
                ? _c("div", { staticClass: "img-item item-left" }, [
                    _vm.imgSrcList.length > 1 && _vm.imgSrcList[1].img
                      ? _c("img", {
                          staticClass: "img-left",
                          style: _vm.contentStyleBanner,
                          attrs: {
                            src:
                              _vm.imgSrcList.length > 1 &&
                              _vm.imgSrcList[1].img,
                            alt: "",
                          },
                        })
                      : _c(
                          "div",
                          {
                            staticClass: "empty-box empty-left",
                            style: _vm.contentStyleBanner,
                          },
                          [
                            _c("span", {
                              staticClass: "iconfont iconfont icontupian",
                            }),
                          ]
                        ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "img-item",
                  class: _vm.swiperType == 0 ? "item-middle" : "item-middle-2",
                },
                [
                  _vm.imgSrcList.length && _vm.imgSrcList[0].img
                    ? _c("img", {
                        staticClass: "img-middle",
                        style: _vm.contentStyleBanner,
                        attrs: {
                          src: _vm.imgSrcList.length && _vm.imgSrcList[0].img,
                          alt: "",
                        },
                      })
                    : _c(
                        "div",
                        {
                          staticClass: "empty-box empty-middle",
                          style: _vm.contentStyleBanner,
                        },
                        [
                          _c("span", {
                            staticClass: "iconfont iconfont icontupian",
                          }),
                        ]
                      ),
                  _vm._v(" "),
                  _c("div", [
                    _vm.docType === 0
                      ? _c(
                          "div",
                          { staticClass: "dot more-dot", style: _vm.dotStyle },
                          [
                            _c("div", {
                              staticClass: "dot-item",
                              style: {
                                background: _vm.themeStyle
                                  ? _vm.configObj.docColor.color[0].item
                                  : _vm.mobileTheme,
                              },
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "dot-item" }),
                            _vm._v(" "),
                            _c("div", { staticClass: "dot-item" }),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.docType === 1
                      ? _c(
                          "div",
                          {
                            staticClass: "dot more-dot line-dot",
                            style: _vm.dotStyle,
                          },
                          [
                            _c("div", {
                              staticClass: "line_dot-item",
                              style: {
                                background: _vm.themeStyle
                                  ? _vm.configObj.docColor.color[0].item
                                  : _vm.mobileTheme,
                              },
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "line_dot-item" }),
                            _vm._v(" "),
                            _c("div", { staticClass: "line_dot-item" }),
                          ]
                        )
                      : _vm._e(),
                  ]),
                ]
              ),
              _vm._v(" "),
              _vm.swiperType == 0
                ? _c("div", { staticClass: "img-item item-right" }, [
                    _vm.imgSrcList.length > 2 && _vm.imgSrcList[2].img
                      ? _c("img", {
                          staticClass: "img-right",
                          style: _vm.contentStyleBanner,
                          attrs: {
                            src:
                              _vm.imgSrcList.length > 2 &&
                              _vm.imgSrcList[2].img,
                            alt: "",
                          },
                        })
                      : _c(
                          "div",
                          {
                            staticClass: "empty-box empty-right",
                            style: _vm.contentStyleBanner,
                          },
                          [
                            _c("span", {
                              staticClass: "iconfont iconfont icontupian",
                            }),
                          ]
                        ),
                  ])
                : _vm._e(),
            ]),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }